import { projectUrls } from '../config/projectUrls';

export const setTemplate = () => {
  const win = window;
  const origin = win.location.origin;

  let templateId = null;

  switch (origin) {
    case projectUrls.LOCAL:
    case projectUrls.SKARB:
      templateId = '01';
      break;
    case projectUrls.KYIVLIKY:
      templateId = '04';
      break;

    case projectUrls.KLASNAAPTEKA:
      templateId = '05';
      break;

    default:
      templateId = '01';
  }

  win.template = templateId;
};
